import { makeCommonStore, FormField } from '../commons'
import InvoiceService from '@/services/InvoiceService.js'

const store = {
  ...makeCommonStore(
    {
      service: InvoiceService,
      fields: [
        new FormField({
          name: 'id',
          hidden: true
        }),
        new FormField({
          name: 'service',
          type: 'select',
          hidden: true,
          items: []
        }),
        new FormField({
          name: 'invoice_no',
          label: 'Invoice number',
          hidden: true
        }),
        new FormField({
          name: 'po_number',
          label: 'P.O. number',
          md: 12
        }),
        new FormField({
          name: 'customer',
          type: 'select',
          label: 'Customer',
          rules: [ 'required' ],
          hidden: true,
          items: [],
          md: 12
        }),
        new FormField({
          name: 'issue_time',
          type: 'date',
          label: 'Invoice date',
          value: ''
        }),
        new FormField({
          name: 'due_date',
          type: 'date',
          label: 'Payment due',
          value: ''
        }),
        new FormField({
          name: 'invoice_items',
          hidden: true
        }),
        new FormField({
          name: 'notes',
          hidden: true
        })
      ]
    },
    ['fields']
  ),
  namespaced: true
}

store.getters = {
  ...store.getters,

  prodServices (state) {
    return state._data.fields[1].items
  },
  invoiceNo (state) {
    return state._data.fields[2].value
  },
  customer (state) {
    return state._data.fields[4].value
  },
  customerList (state) {
    return state._data.fields[4].items
  },
  notes (state) {
    return state._data.fields[8].value
  }
}

store.mutations = {
  ...store.mutations,

  updateCustomerOptions (state, options) {
    state._data.fields[4].items = options
  },
  updateProdServiceOptions (state, options) {
    state._data.fields[1].items = options
  },
  updateNotes (state, value) {
    state._data.fields[8].value = value
  }
}

store.actions = {
  ...store.actions,

  setCustomerOptions ({ commit, state }, data) {
    commit('updateCustomerOptions', data)
  },
  setProdServiceOptions ({ commit, state }, data) {
    commit('updateProdServiceOptions', data)
  },
  setNotes ({ commit, state }, data) {
    commit('updateNotes', data)
  }
}

export default store
